import { render, staticRenderFns } from "./DialogView.vue?vue&type=template&id=fbf936f4&scoped=true"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"
import style0 from "./DialogView.vue?vue&type=style&index=0&id=fbf936f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf936f4",
  null
  
)

export default component.exports